import { render, staticRenderFns } from "./AgendaAppuntamentiComponent.vue?vue&type=template&id=92a96cfc&scoped=true"
import script from "./AgendaAppuntamentiComponent.vue?vue&type=script&lang=js"
export * from "./AgendaAppuntamentiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a96cfc",
  null
  
)

export default component.exports